import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as scoreCardAPI from 'api/Scorecard';
import { openSnackbar } from 'store/reducers/snackbar';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';

const initalState = {
  pagination: {
    pageSize: 10,
    currentPage: 1,
    totalRecords: null,
    index: 1
  },
  data: null,
  ScorecardPayload: {},
  // totalRecord: null,
  downloadreport: null,
  ui: {
    loading: false,
    msg: '',
    downloadreport: {
      loading: false,
      status: 'initalState'
    }
  },
  column: [
    { title: 'Lob', key: 'Lob', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
    { title: 'Total Calls', key: 'Total Calls', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 190 },
    { title: 'CQ', key: 'CQ', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 210 },
    { title: 'csat', key: 'CSAT', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 210 },
    { title: 'Completed Calls', key: 'Completed Calls', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
    { title: 'Insuff Trans Calls', key: 'Insuff Trans Calls', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 190 },
    { title: 'Processed Calls', key: 'Processed Calls', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 150 },
    { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
  ],
  expandData: null,
  interval: null,
  status: 'init',
  panelshow: true,
  hiddenColumns: [],
  allColumns: null,
  setHiddenColumns: null
};

const getScoreCardState = (state) => state.reporting;

const getScoreCardData = createAsyncThunk('scorecard/getScoreCardData', async ({ filterResult, signal }) => {
  const res = await scoreCardAPI.getReportingData(filterResult, signal);
  return res.data?.data;
});
const scorecardFeatureWiseGraphData = createAsyncThunk('scorecard/scorecardFeatureWiseGraph', async ({ filterResult }) => {
  const res = await scoreCardAPI.scorecardFeatureWiseGraph(filterResult);
  return res.data?.data;
});

const getDownloadReport = createAsyncThunk('scorecard/getDownloadReport', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await scoreCardAPI.getDownloadReport(params);
    return res.data;
    // return {};
  } catch (error) {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response.data?.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return rejectWithValue(error);
  }
});

const scoreCardSlice = createSlice({
  name: 'scorecard',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
      
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setScorecardPayload: (state, action) => {
      state.ScorecardPayload = action.payload;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },
    setPaginationData: (state, action) => {
      state.pagination = {
        pageSize: action.payload.pageSize,
        index: action.payload.index
      };
    },
    setInterval: (state, action) => {
      state.interval = action.payload;
    },
    setPanelShow: (state, action) => {
      state.panelshow = action.payload;
    },

    setAllcolumn: (state, action) => {
      // state.hiddenColumns = action.payload.hiddenColumns;
      // state.setHiddenColumns = action.payload;
      state.allColumns = action.payload.MemoizedHeaders;
    },
    sethide: (state, action) => {
      state.hiddenColumns = action.payload;
      // if (!state.hiddenColumns.includes(action.payload)) {
      //   state.hiddenColumns.push(...action.payload);
      // } else {
      //   const index = state.hiddenColumns.indexOf(action.payload);
      //   if (index !== -1) {
      //     state.hiddenColumns.splice(index, 1);
      //   }
      // }
    }
  },
  extraReducers: {
    [getScoreCardData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getScoreCardData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload.basic_call_info;
      state.column = action.payload.fields;
      state.pagination.totalRecords = action.payload.total_records;
    },

    [getScoreCardData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [scorecardFeatureWiseGraphData.pending]: (state) => {
      state.status = 'init';
      state.expandData = null;
    },

    [scorecardFeatureWiseGraphData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.expandData = action.payload;
    },

    [scorecardFeatureWiseGraphData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
    },
    [getDownloadReport.pending]: (state) => {
      state.ui.downloadreport.status = 'init';
      state.ui.downloadreport.loading = true;
      state.downloadreport = null;
    },

    [getDownloadReport.fulfilled]: (state, action) => {
      state.ui.downloadreport.status = 'idle';
      state.ui.downloadreport.loading = false;
      state.downloadreport = action.payload;
    },

    [getDownloadReport.rejected]: (state, action) => {
      state.ui.downloadreport.status = 'error';
      state.ui.downloadreport.loading = false;
      state.error = action.error.message;
    }
  }
});

export const { setCurrentPage, setPageSize, setPaginationData, setInterval, setScorecardPayload, setPanelShow, setAllcolumn, sethide } =
  scoreCardSlice.actions;

export default scoreCardSlice.reducer;

export { getScoreCardState, scorecardFeatureWiseGraphData, getScoreCardData, getDownloadReport };
